import React, { useState, useEffect } from 'react';
import { supabase } from '../../../lib/supabase';

const FoundersSection = () => {
  const [founders, setFounders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadFounders();
  }, []);

  const loadFounders = async () => {
    try {
      const { data, error } = await supabase?.from('founders')?.select('*')?.order('display_order', { ascending: true });

      if (error) throw error;
      setFounders(data || []);
    } catch (error) {
      console.error('Error loading founders:', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <section className="py-24 lg:py-32 relative bg-black/20">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-8">
          <div className="text-center text-white">Loading founders...</div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-24 lg:py-32 relative bg-black/20">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight">
            Meet the <span className="gradient-text">Founders</span>
          </h2>
          <p className="text-base sm:text-lg text-white/70 max-w-3xl mx-auto">
            BardPlay was started by three friends who shared a mutual love for Shakespeare. Brothers Bradley and Bowie Bundlie and Samantha Leeds met in high school and realized that access to proper Shakespeare training made these timeless plays not only more fun to read but also more fun to perform.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {founders?.map((founder) => (
            <div
              key={founder?.id}
              className="modern-card text-center hover:scale-105 transition-transform duration-300"
            >
              <div className="flex justify-center mb-6">
                <div className="w-32 h-32 rounded-full bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center border-4 border-white/10">
                  <span className="text-white font-bold text-4xl">
                    {founder?.initials || founder?.name?.split(' ')?.map(n => n?.[0])?.join('')}
                  </span>
                </div>
              </div>

              <h3 className="text-xl sm:text-2xl font-bold text-white mb-2">
                {founder?.name}
              </h3>
              <p className="text-purple-400 font-semibold mb-4 text-sm sm:text-base">
                {founder?.role}
              </p>
              <p className="text-white/70 leading-relaxed text-sm sm:text-base">
                {founder?.bio}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FoundersSection;